import checkVisible from './checkVisible';

const animateOnView = {

    ui: {
    },

    init: function () {
        this.bindUI();
        this.bindEvents();
        this.onView();
    },

    bindUI: function () {
        this.ui.$document = $(document);
        this.ui.$toAnimate = $('.js-animate-on-view');
    },

    bindEvents: function () {
        this.ui.$document.on('scroll', this.onView.bind(this));
    },

    onView: function () {
        if (this.ui.$toAnimate.length > 0){
            for(var i = 0, len = this.ui.$toAnimate.length; i < len; i++){
                
                // let threshold = this.ui.$toAnimate.eq(i).attr("data-animate-threshold")
                // let threshold = (this.ui.$toAnimate.eq(i).hasClass("js-animate-on-view-early")) ? 0 : window.innerHeight/3 ;
                let threshold = window.innerHeight/6 ;
                
                if (!this.ui.$toAnimate.eq(i).hasClass("animate") && checkVisible(this.ui.$toAnimate.eq(i)[0], threshold, "bellow") || checkVisible(this.ui.$toAnimate.eq(i)[0], threshold, "above")) {
                    this.ui.$toAnimate.eq(i).addClass("animate");
                    this.ui.$toAnimate.eq(i).find(".js-before-animate").each(function(index){
                        let $this = $(this)
                        setTimeout(function(){
                            $this.removeClass("js-before-animate");
                        },index*150);
                    });
                    this.ui.$document.unbind('scroll', this.onView);
                }
                // if(!checkVisible(this.ui.$toAnimate.eq(i)[0], 0)){
                //     this.ui.$toAnimate.eq(i).removeClass("animate");
                // }
            }
        }
    },
};

module.exports = animateOnView;